




















import { defineComponent } from '@nuxtjs/composition-api';
import { PRODUCER_AREA_MENU } from '~/constants';

export default defineComponent({
  setup(props, { emit }) {
    /**
     * カテゴリ検索
     * @param id カテゴリのid
     * @param column 左カラムの項目
     */
    const emitCategory = (query?: string, column?: string) => {
      emit('area', query, column);
    };
    return { PRODUCER_AREA_MENU, emitCategory };
  },
});
